import axios from '@axios'

export default {
  namespaced: true,
  state: {
    countryList: [],
    currencyList: [],
    defaultIso: null,
  },
  getters: {},
  mutations: {
    SET_COUNTRY_LIST(state, data) {
      state.countryList = data
    },
    SET_DEFAULT_ISO(state, data) {
      state.defaultIso = data
    },
    SET_CURRENCY_LIST(state, data) {
      state.currencyList = data
    },
  },
  actions: {
    async fetchAuthLists({ commit }) {
      try {
        const { data } = await axios.get('/auth/show')
        commit('SET_COUNTRY_LIST', data.options.countries.data)
        commit('SET_DEFAULT_ISO', data.data.countyIsoCode)
        commit('SET_CURRENCY_LIST', data.options.currencies.data)
        return data.data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async fetchAuthInviteLists({ commit }, payload) {
      try {
        const { data } = await axios.get(`/auth/check-token/register-invite/${payload.token}/${payload.id}`)
        commit('SET_COUNTRY_LIST', data.options.countries.data)
        commit('SET_DEFAULT_ISO', data.data.countyIsoCode)
        commit('SET_CURRENCY_LIST', data.options.currencies.data)
        return data
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
